import React, { useState } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useNavigate } from'react-router-dom';
const ErrorBoundary = () => {
    const navigate = useNavigate();
  const handleButtonClick = (path) => {
    navigate(path)
}
  const ErrorFallback = () => (
    <Container maxWidth="sm">
      <Box
        textAlign="center"
        pt={8}
        pb={8}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <ErrorOutlineIcon fontSize="large" color="error" />
        <Typography variant="h4" color="error" gutterBottom>
          發生了一些錯誤
        </Typography>
        <Typography variant="body1" paragraph>
          很抱歉，請回到首頁。
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={()=> handleButtonClick('/app')}
        >
          回首頁
        </Button>
      </Box>
    </Container>
  );

  return (
    <>
       
        <ErrorFallback />

    </>
  );
};

export default ErrorBoundary;
